import { Suspense, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router';
import { Loading } from '../components/ui/Status';
import { handleAndroidBackButton, handleAppLinks } from '../lib/native';

/**
 * Wraps every route: lazy pages load behind one fallback, Android's back button works, and a
 * shared Libellus link opened on Android lands on the right screen.
 */
export function RootLayout() {
  const navigate = useNavigate();
  useEffect(() => handleAndroidBackButton(() => void navigate(-1)), [navigate]);
  useEffect(() => handleAppLinks((path) => void navigate(path)), [navigate]);

  return (
    <Suspense fallback={<Loading />}>
      <Outlet />
    </Suspense>
  );
}
